import { ApiResponse } from 'App'
import { AxiosError } from 'axios'

const assignAffiliateSilentErrors = [
  'client_under_main_ib',
  'lead_is_sgl',
  'affiliate_created_after_lead',
  'affiliate_and_lead_emails_are_same',
  'client_under_ib',
]

const equitySilentErrors = [
  'not_enough_trading_account_equity',
  'not_enough_trading_account_equities',
]

const rebatesSilentErrors = ['trading_account_has_another_introducing_broker_rebate']

export const SilentErrors = [
  ...assignAffiliateSilentErrors,
  ...rebatesSilentErrors,
  ...equitySilentErrors,
  'same_region_team',
  'introducing_broker_already_in_use',
]

export const isErrorSilent = (
  response: ApiResponse | AxiosError<{ code: string }, unknown>
): boolean => SilentErrors.includes(response?.response?.data?.code ?? '')
